<script>

import Navbar from '@/components/Navbar'
import htmlEn from '@/assets/generated/mailserver-ansible.en.html'
import htmlDe from '@/assets/generated/mailserver-ansible.de.html'

export default {
  name: 'mailserver-ansible',
  components: { Navbar },
  computed: {
    raw3(){
      return this.$i18n.locale === 'de' ? htmlDe : htmlEn;
    }
  }
}
</script>

<template>
  <div>
    <navbar :lightTheme="true" :blogpost="true" />
    <div id="raw" v-html="raw3"></div>
  </div>
</template>

<style lang="scss" scoped>
  @import "@/assets/css/fcc.scss";
</style>
